import { render, staticRenderFns } from "./UsersTableMenu.vue?vue&type=template&id=0ae79be8&scoped=true&"
import script from "./UsersTableMenu.vue?vue&type=script&lang=js&"
export * from "./UsersTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae79be8",
  null
  
)

export default component.exports